// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__29Pqz","name":"ConsentHeader_name__2CXCI","birthday":"ConsentHeader_birthday__3JWnU","skeleton":"ConsentHeader_skeleton__1ZThR"};